import Hero from './home/Hero'
import Features from './home/Features';
import CallToAction from './home/CallToAction';
import HowToPlay from './home/HowToPlay'
import SNSLinks from './home/Links';
import SeasonRankings from './home/SeasonRankings';
import License from './home/License';

function Home() {
    return (
    <>
        <Hero />
        <HowToPlay className="bg-white" />
        <Features className="bg-light" />
        <SeasonRankings className="bg-white" />
        <License className="bg-light" />
        <SNSLinks className="bg-white" />
        <CallToAction />
    </>
  );
}
export default Home
